import Tenant from '@/tenants/entities/tenant'
import cloneDeep from 'lodash/cloneDeep'
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import countriesService from '@/locations/services/countries-service'
import Country from '@/locations/models/country'

@Component
export default class TenantDialog extends Vue {

  @Ref()
  private validator!: ValidationObserver

  private dialog = false
  private editMode = false
  private tenant = new Tenant()
  private countries: Country[] = []

  public create(tenant?: Tenant) {
    this.tenant = tenant || new Tenant()
    this.dialog = true
    this.editMode = false
    if (this.validator) {
      this.validator.reset()
    }
  }

  public edit(tenant: Tenant) {
    this.tenant = cloneDeep(tenant)
    this.dialog = true
    this.editMode = true
    this.reset()
  }

  public async save() {
    if (await this.validator.validate()) {
      this.$emit(this.editMode ? 'update' : 'save', this.tenant)
    }
  }

  public cancel() {
    this.$emit('cancel')
    this.dialog = false
  }

  public close() {
    this.dialog = false
  }

  private reset() {
    if (this.validator) {
      this.validator.reset()
    }
  }

  private mounted() {
    this.countries = countriesService.findAllAsync()
  }
}
